import { CheerzApiBannerKountries } from "@Types/api/bannerKountries";
import { BannerKountries } from "@Types/bannerKountries";

export function convertFromApiToBannerKountries(
  jsonContent: CheerzApiBannerKountries
): BannerKountries {
  return {
    backgroundColor: jsonContent.background_color,
    banners: jsonContent.banners,
  };
}
